module.exports = __webpack_public_path__ + "static/img/3.dbc4940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/3.png
// module id = 8iiO
// module chunks = 0